<template>
  <div class="form-check" :class="[{ disabled: disabled }]">
    <label class="form-check-label">
      <input
        class="form-check-input"
        type="checkbox"
        :disabled="disabled"
        @input="onChanged"
        :checked="modelValue"
      />
      <span class="form-check-sign"></span>
      <slot> <span v-if="inline">&nbsp;</span> </slot>
    </label>
  </div>
</template>
<script>
import { ref, defineComponent } from 'vue';

export default defineComponent({
  name: 'Checkbox',

  emits: ['update:modelValue'],

  props: {
    required: Boolean,
    label: {
      type: String,
      description: 'Input label',
    },
    error: {
      type: String,
      description: 'Input error',
      default: '',
    },
    value: {
      type: [String, Number],
      description: 'Input value',
    },
    addonRightIcon: {
      type: String,
      description: 'Input icon on the right',
    },
    addonLeftIcon: {
      type: String,
      description: 'Input icon on the left',
    },
    type: {
      type: String,
      description: 'Type of the input',
    },
    modelValue: Boolean,
    placeholder: {
      type: String,
      default: '',
    },
    additionalClass: {
      type: String,
      default: '',
    },
    disabled: Boolean,
  },

  setup(props, { emit }) {
    function onChanged(e) {
      emit('update:modelValue', e.currentTarget.checked);
    }

    return {
      onChanged,
    };
  },
});
// export default {
//   name: 'base-checkbox',
//   model: {
//     prop: 'checked'
//   },
//   props: {
//     checked: [Array, Boolean],
//     disabled: Boolean,
//     inline: Boolean,
//     hasError: Boolean
//   },
//   data() {
//     return {
//       cbId: '',
//       touched: false
//     };
//   },
//   computed: {
//     model: {
//       get() {
//         return this.checked;
//       },
//       set(check) {
//         var temp = false;
//         if (!this.touched) {
//           temp = true;
//         }else{
//           temp = false;
//         }
//         this.$emit('input', temp);
//       }
//     },
//     inlineClass() {
//       if (this.inline) {
//         return `form-check-inline`;
//       }

//       return false;
//     },
//     listeners() {
//       return {
//         ...this.$listeners,
//         input: this.onInput,
//         blur: this.onBlur,
//         focus: this.onFocus,
//         change: this.onChange,
//       };
//     }
//   },
//   methods: {
//     onChange(evt){
//       console.log(evt);
//       this.$emit('change',this.touched);
//     },
//     onInput(evt) {
//       if (!this.touched) {
//         this.touched = true;
//       }else{
//         this.touched = false;
//       }
//       this.$emit('input', this.touched);
//     },
//     onFocus(evt) {
//       this.focused = true;
//       this.$emit('focus', evt)
//     },
//     onBlur(evt) {
//       this.focused = false;
//       this.$emit('blur', evt)
//     }
//   },
//   created() {
//     this.cbId = Math.random()
//       .toString(16)
//       .slice(2);
//   }
// };
</script>
